// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"7adfee1a","145":"7203560d","147":"04df1490","205":"d6224561","320":"1571a2df","544":"74f0ad94","617":"cfd77802","654":"9d497850","905":"0556098c"}[chunkId] + ".chunk.js";
};